import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import themeChangeColor from "../configs/themeChangeColor";

import ThemeHookProps from "../props/theme";
import { updateTheme } from "../redux/actions";

export const useTheme = (): ThemeHookProps => {
  const dispatch = useDispatch();
  const getTheme = useSelector((state: any) => state.themeColor);

  const [theme, setTheme] = useState(getTheme);

  useEffect(() => {
    dispatch(updateTheme(theme));
  }, [dispatch, theme]);

  return [themeChangeColor(getTheme), setTheme];
};
